<template>
    <div class="video-page">
        <p class="current">当前位置：<span>视频</span></p>
        <div class="artcle-box">
            <div class="menu">
            <!-- default-active="0" -->
                <el-menu
            
                    class="el-menu-vertical-demo"
                    
                    background-color="#fff"
                    text-color="#000"
                    active-text-color="#00a8a8">
                        <el-menu-item index="1" @click="ClickArry()">全部</el-menu-item>
                        <!-- <el-menu-item index="1" >全部</el-menu-item> -->
                        <el-menu-item v-for="item,index in maintypeData" :key="item.cate_id" :index="index+2" @click="handleListarticle(item)">
                        <!-- <el-menu-item v-for="item,index in maintypeData" :key="item.cate_id" :index="index+2"> -->
                            <!-- <i class="el-icon-menu"></i> -->
                            <span slot="title">{{ item.cate_name }}</span>
                        </el-menu-item>
                
                </el-menu>
            </div>
           <videoList :videoData="videoData" :type="1" :activeIndex="1"></videoList>
        </div>
    </div>
</template>
<script>
import videoList from './videoList.vue'
export default {
    data(){
        return{
            parent_cate_value: ['maintype'],
            maintypeData:[],
            cate: '',
            hideOnSinglePage: true,
            total: 0,
            videoList: [],
            videoData: []
        }
    },
    components:{
        videoList
    },
    methods:{
         //   获取菜单
        getMenuList(){
            const data = {
                parent_cate_value: this.parent_cate_value
            }
            this.$store.dispatch('video/listcate', data)
                .then((res) => {
                    console.log(res);
                    this.maintypeData = []
                    if(res.ok){
                        this.maintypeData = res.data
                        
                    }
                
                })
                .catch((err) => {
                    
                    console.log(err);
                }) 
        },
        ClickArry(){
            let data = {
                pageNum: 1,
                pageSize: 9,
                cate: '',
                keywords: '',
            }
            this.videoData = data
        },
        handleListarticle(value){
            this.cate = value.cate_id
            console.log(value);
            let data = {
                pageNum: 1,
                pageSize: 9,
                cate: value.cate_id,
                keywords: '',
            }
            this.videoData = data
           
        },
      
      
    },
    mounted(){
        // this.$refs.videoPlayer.play();
    },
    created(){
        this.getMenuList()
       
    }

}
</script>
<style scoped>
.video-page{
    width: 1200px;
    padding: 10px 10px;
    margin: 45px auto;
    background: #fff;
}
.current{
    margin-top: -45px;
    position: relative;
    font-size: 17px;
    color: #333;
}
.current span{
    font-size: 16px;
    cursor: pointer;
    color: #666666;
}
.artcle-box{
    width: 1200px;
    margin: 25px auto;
    display: flex;
    justify-content: flex-start;
    
}


.menu{
    width: 250px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    align-self: flex-start;
    text-align: center;
}

.el-menu-item {
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 18px;
}
.el-menu-item.is-active {
  background-color: rgba(0,168,168,.1) !important;
}
.el-menu-item:hover{
    background-color: rgba(0,168,168,.1) !important;

}
/* .video-box{
    display: flex;
    justify-content: space-between;
    background: pink;
}
*/



</style>